import { createSlice } from "@reduxjs/toolkit";
import {
  fetchUserInfoBuilder,
  loginBuilder,
  logoutBuilder,
  signupBuilder,
  forgotPasswordBuilder,
  forgotPasswordSendCodeBuilder,
} from "./builder";

const initialState = {
  loggedIn: null,
  login: {
    attempt: false,
    success: false,
    error: null,
  },
  signup: {
    attempt: false,
    success: false,
    error: null,
  },
  forgotPassword: {
    attempt: false,
    success: false,
    error: null,
  },
  forgotPasswordSendCode: {
    attempt: false,
    success: false,
    error: null,
  },
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    loginBuilder(builder);
    fetchUserInfoBuilder(builder);
    logoutBuilder(builder);
    signupBuilder(builder);
    forgotPasswordBuilder(builder);
    forgotPasswordSendCodeBuilder(builder);
    builder.addCase("logout", () => ({ ...initialState, loggedIn: false }));
  },
});

export const {} = authSlice.actions;

export const selectLoggedIn = (state) => state.auth.loggedIn;

export default authSlice.reducer;
